import products from './products.js'
export default {
    data(){
        return{
            //products lazy loading
            products_loading: false,
            temp_products: [],
            product_count: 0,
            product_scrollable: false,
            products_visible: false,
            products:[]
        }
    },
    mixins: [products],
    methods:{
        async searchProductDebouncer(product){
            this.products_loading = true
            let response = await this.ListProducts({
                search_key: product,
                sort_value: 1,
                sort_key: "is_star",
            })
            this.products = response.response
            this.products = this.products.filter(x => {
                if(x.name){
                    return x
                }
            })
            this.product_count = this.products.length
            this.products_loading = false
            this.product_scrollable = false
        },
        async searchProduct(product){
            this.products_loading = true
            let response = await this.ListProducts({
                search_key: product,
                sort_value: 1,
                sort_key: "is_star",
            })
            this.products = response.response
            this.products = this.products.filter(x => {
                if(x.name){
                    return x
                }
            })
            this.product_count = this.products.length
            this.products_loading = false
            this.product_scrollable = false
        },
        async reachedEndOfProducts(reached) {
            this.products_visible = reached
            if (reached) {
                if (this.product_scrollable == false) {
                    this.products_loading = true
                    let response = await this.ListProducts({
                        skip: this.product_count,
                        limit: 10,
                        search_key: "",
                        sort_value: 1,
                        sort_key: "is_star",
                    })
                    this.temp_products = response.response.length;
                    if (response.skip == this.product_count) {
                        if (this.temp_products > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                this.products.push(el);
                                this.products = this.products.filter(x => {
                                    if(x.name){
                                        return x
                                    }
                                })
                            });
                            this.product_count += response.response.length;
                            this.products_loading = false
                        } else {
                            this.product_scrollable = true
                            this.products_loading = false
                        }
                    }
                    this.products_loading = false
                }
            }
        },
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/product_lazy_loading.js